// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"338ace24","549":"c0c85503"}[chunkId] + ".chunk.css";
};